export const serviceLevelAgreement2025 = `

# Service Level Agreement

> Last updated: November 1, 2025

> This document complements the Endress+Hauser Master Service Agreement for the provision of Netilion and the related digital services.

## Service performance

### Availability

Endress+Hauser will use commercially reasonable efforts to make the services available with a monthly uptime of 99.9%.

### Maintenance

The given availability excludes planned downtime due to, for example, maintenance. Planned downtimes are announced in advance per email and published on [http://status.netilion.endress.com](http://status.netilion.endress.com)

## Service support

### Eligibility to service support

Endress+Hauser provides a FAQ site available on [https://help.netilion.endress.com](https://help.netilion.endress.com). This resource provides answers to common questions and guide on using the Endress+Hauser’s services.

Netilion users with an active and valid paid subscription are entitled to additional personalized support from the Endress+Hauser support team.

### Scope

The Endress+Hauser service support described in this Service Level Agreement is limited to the services described in the corresponding Definition of Service. 
The service support is aimed to:

+ Identifying problems preventing accessing the subscribed services
+ Providing remote assistance for resolving the problems relating to the functionality of the services

The service support does not extend to:

+ Developing customer specific functions
+ Tailoring the services the customer needs
+ Training on the usage of the services
+ Support on topics which are the customer responsibility, like internet access of field network connection
+ Instrument related support
+ Any other services not listed in this documentation

### Access to service support

The Endress+Hauser service support can be contacted through the support function for users with an active paid subscription. The information related to the support requests are communicated through this portal.

### Availability of service support

Service support requests may be submitted at any time. The Endress+Hauser service support maximum response time is 24 hours from the creation of the support request, excluding weekends and bank holidays at the seat of contracting entity of Endress+Hauser.
`;
